import { render } from "./FreeBenefits.vue?vue&type=template&id=b1375f4a&scoped=true"
import script from "./FreeBenefits.vue?vue&type=script&lang=js"
export * from "./FreeBenefits.vue?vue&type=script&lang=js"

import "./FreeBenefits.vue?vue&type=style&index=0&id=b1375f4a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1375f4a"]])

export default __exports__